module.exports = __webpack_public_path__ + "cb62979151515ad6d7b5d15a2c841f6b.svg";